/**
 * 邮件自动任务触发
 */

import _ from "lodash";
import { HandlePhpFetch } from "../utils/fetch";
import { getCookieItem } from "@/lib/commonService";
import { getSiteConfiguration } from "../utils/configUtils";

const backendUrl = "delay/mail/trigger";
const isLogin = !!getCookieItem("jwt");
const checkParams = (param0: Record<string, any>, domain: string) =>
    !getSiteConfiguration("enableAutoTask", domain) || _.isEmpty(param0);

const checkParamsWithLogin = (param0: Record<string, any>, domain: string) =>
    !isLogin || checkParams(param0, domain);
/**
 *
 * @param couponCode:优惠券code
 * @param email：*邮箱
 * @param delayType：*延时任务的类型
 * @param domain
 * @returns
 */

// 点击领取优惠券
export const addCouponClickEventTask = (param0: Record<string, any>) => {
    const { domain, ...rest } = param0;
    console.log("-addCoupon-", checkParams(param0, domain));
    if (checkParams(param0, domain)) return;
    const promises = [];
    // 优惠券领取
    promises.push(
        HandlePhpFetch.post(backendUrl, {
            delayType: "1",
            ...rest,
        }),
    );

    // 优惠券过期
    promises.push(
        HandlePhpFetch.post(backendUrl, {
            delayType: "2",
            ...rest,
        }),
    );

    return Promise.all(promises);
};

// 点击商品,在登录状态下，只在两种事件下调用： 1产品详情页点击SKU，4列表页点击详情页
export const addProductsClickEventTask = (param0: Record<string, any>) => {
    const { domain, email } = param0;
    console.log("-addProductsClick-", checkParamsWithLogin(param0, domain));
    if (checkParamsWithLogin(param0, domain)) return;
    return HandlePhpFetch.post(backendUrl, {
        delayType: "3",
        email,
    });
};

// 添加购物车
export const addToCartClickEventTask = (param0: Record<string, any>) => {
    const { domain, email } = param0;
    console.log("-addToCart-", checkParamsWithLogin(param0, domain));
    if (checkParamsWithLogin(param0, domain)) return;
    return HandlePhpFetch.post(backendUrl, {
        delayType: "5",
        email,
    });
};

// 添加收藏
export const addFavouriteClickEventTask = (param0: Record<string, any>) => {
    const { domain, email } = param0;
    console.log("-addFavourite-", checkParamsWithLogin(param0, domain));
    if (checkParamsWithLogin(param0, domain)) return;
    return HandlePhpFetch.post(backendUrl, {
        delayType: "4",
        email,
    });
};
